/* Panastore PDP — behaviour ported from the approved demo, driven by live product data. */
(function () {
  var root = document.querySelector('.pspdp'); if (!root) return;
  var variants = JSON.parse(document.getElementById('pspdp-variants').textContent);
  var cfg = JSON.parse(document.getElementById('pspdp-config').textContent);

  function money(cents) {
    var f = cfg.moneyFormat || '£{{amount}}';
    var s = (cents / 100).toFixed(2);
    if (f.indexOf('no_decimals') > -1) s = String(Math.round(cents / 100));
    return f.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '').replace(/\s*GBP\s*/, '').trim();
  }

  /* ---------- gallery: selected variant's photo first, then the shared media ---------- */
  var track = document.getElementById('pspdp-track'), thumbs = document.getElementById('pspdp-thumbs');
  var items = Array.prototype.slice.call(track.children), tbs = Array.prototype.slice.call(thumbs.children);
  var gi = root.querySelector('.pspdp-gi'), gn = root.querySelector('.pspdp-gn');
  var prev = root.querySelector('.pspdp-garrow--prev'), next = root.querySelector('.pspdp-garrow--next');
  var dots = document.getElementById('pspdp-dots');
  var visible = [], cur = 0;

  /* Media tagged to an option value (a second image per colour, e.g. a size guide): Shopify allows
     one image per variant, so extra per-colour media is matched by name instead. A media item belongs
     to an option value when (a) its alt text, split on "-", has a segment equal to that value (any case),
     or (b) its filename, split on "-", has a segment equal to that value EXACTLY as written, and the
     value is a word with lowercase letters, spaces ignored ("…-FluorescentYellow-SizeGuide.png" -> Fluorescent Yellow;
     Shopify strips spaces from filenames). Rule (b) is case-sensitive and skips all-caps values (XL, 2XL)
     so SKU-style filenames such as PSC-LTBELT-M3-TAN-KARL_Group or ...-TEE-XL-1-Z never count.
     Untagged media is shared. */
  function norm(s) { return String(s || '').toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ').trim(); }
  var optVals = {}, optRaw = {};
  variants.forEach(function (v) { (v.options || []).forEach(function (o) { optVals[norm(o)] = true; if (/[a-z]/.test(String(o))) optRaw[String(o).replace(/[^a-z0-9]/gi, '').toLowerCase()] = norm(o); }); }); // filenames lose their spaces on upload, so compare without them
  function tagOf(li) {
    if (li.dataset.tag !== undefined) return li.dataset.tag || null;
    var tag = null, img = li.querySelector('img');
    String(li.dataset.alt || '').split(/\s*-\s*/).forEach(function (g) { if (!tag && optVals[norm(g)]) tag = norm(g); });
    if (!tag && img) {
      var f = decodeURIComponent((img.getAttribute('src') || '').split('?')[0].split('/').pop()).replace(/\.[a-z0-9]+$/i, '').replace(/_/g, ' ');
      f.split(/\s*-\s*/).forEach(function (g) { g = g.replace(/[^a-z0-9]/gi, '').toLowerCase(); if (!tag && g && optRaw[g]) tag = optRaw[g]; });
    }
    li.dataset.tag = tag || ''; return tag;
  }
  function hasOpt(variant, tag) { return !!variant && (variant.options || []).some(function (o) { return norm(o) === tag; }); }

  function arrange(variant) {
    var own = variant && variant.featured_media ? String(variant.featured_media.id) : null;
    visible = [];
    // variant photo first
    if (own) { var o = items.filter(function (li) { return li.dataset.mediaId === own; })[0]; if (o) visible.push(o); }
    // then media tagged to this variant's option values (its size guide), hiding other colours' tagged media
    items.forEach(function (li) { if (li.dataset.variantIds || li.dataset.mediaId === own) return; var t = tagOf(li); if (t && hasOpt(variant, t)) visible.push(li); });
    // then media not attached to any variant and not tagged (hide other variants' photos)
    items.forEach(function (li) { if (!li.dataset.variantIds && li.dataset.mediaId !== own && !tagOf(li)) visible.push(li); });
    if (!visible.length) visible = items.slice();
    // apply order + visibility to both lists
    items.forEach(function (li) { li.hidden = visible.indexOf(li) < 0; });
    visible.forEach(function (li, i) { li.style.order = i; var t = tbs.filter(function (b) { return b.dataset.mediaId === li.dataset.mediaId; })[0]; if (t) t.style.order = i; });
    tbs.forEach(function (b) { b.hidden = !visible.some(function (li) { return li.dataset.mediaId === b.dataset.mediaId; }); });
    gn.textContent = visible.length;
    var gal = root.querySelector('.pspdp-gallery'); if (gal) gal.classList.toggle('is-single', visible.length < 2); // one visible image: no thumbs, dots, counter or arrows
    if (dots) { dots.innerHTML = ''; visible.forEach(function (li, i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'pspdp-dot'; d.dataset.i = i; d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Image ' + (i + 1)); dots.appendChild(d); }); }
    track.scrollTo({ left: 0 }); setIdx(0);
  }
  // thumbs advance a page at a time (6 on desktop, 4 on mobile), like the live site's thumb slider
  function pageThumbs() {
    var on = tbs.filter(function (b) { return b.classList.contains('is-on'); })[0]; if (!on) return;
    var cs = getComputedStyle(thumbs), padL = parseFloat(cs.paddingLeft) || 0, padR = parseFloat(cs.paddingRight) || 0;
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 8, tw = on.getBoundingClientRect().width;
    var perPage = Math.max(1, Math.round((thumbs.clientWidth - padL - padR + gap) / (tw + gap)));
    var start = Math.floor(cur / perPage) * perPage, first = visible[start] && tbs.filter(function (b) { return b.dataset.mediaId === visible[start].dataset.mediaId; })[0];
    if (!first) return;
    var left = first.getBoundingClientRect().left - thumbs.getBoundingClientRect().left + thumbs.scrollLeft - padL;
    if (Math.abs(thumbs.scrollLeft - left) > 1) thumbs.scrollTo({ left: left, behavior: 'smooth' });
  }
  function setIdx(i) {
    cur = Math.max(0, Math.min(visible.length - 1, i)); gi.textContent = cur + 1;
    prev.hidden = cur === 0; next.hidden = cur >= visible.length - 1;
    tbs.forEach(function (b) { b.classList.toggle('is-on', visible[cur] && b.dataset.mediaId === visible[cur].dataset.mediaId); });
    pageThumbs();
    if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === cur); d.setAttribute('aria-selected', k === cur); });
  }
  function goTo(i) { i = Math.max(0, Math.min(visible.length - 1, i)); visible[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); setIdx(i); }
  // react only once the track has settled: mid-flight positions round to the previous image and flicker the thumb + dash
  var settleT;
  track.addEventListener('scroll', function () {
    clearTimeout(settleT);
    settleT = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setIdx(i); }, 120);
  }, { passive: true });
  prev.addEventListener('click', function () { goTo(cur - 1); });
  next.addEventListener('click', function () { goTo(cur + 1); });
  if (dots) dots.addEventListener('click', function (e) { var d = e.target.closest('.pspdp-dot'); if (d) goTo(+d.dataset.i); });
  thumbs.addEventListener('click', function (e) { var b = e.target.closest('.pspdp-thumb'); if (!b) return; var li = visible.filter(function (x) { return x.dataset.mediaId === b.dataset.mediaId; })[0]; if (li) goTo(visible.indexOf(li)); });
  track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') goTo(cur - 1); if (e.key === 'ArrowRight') goTo(cur + 1); });

  /* ---------- lightbox ---------- */
  var lb = document.getElementById('pspdp-lb');
  if (lb) {
    document.body.appendChild(lb); // escape any transformed ancestor so position:fixed is the viewport
    var stage = document.getElementById('pspdp-lb-stage'), lbImg = document.getElementById('pspdp-lb-img');
    var lbI = lb.querySelector('.pspdp-lb-i'), lbN = lb.querySelector('.pspdp-lb-n');
    var lbPrev = lb.querySelector('.pspdp-lb-arrow--prev'), lbNext = lb.querySelector('.pspdp-lb-arrow--next'), lbClose = lb.querySelector('.pspdp-lb-close');
    var lbCur = 0, lastFocus = null, touchX = null;
    function fullSrc(li) { var im = li.querySelector('img'); return im.dataset.full || im.src; }
    function lbShow(i) {
      lbCur = Math.max(0, Math.min(visible.length - 1, i));
      lb.classList.remove('zoomed');
      var im = visible[lbCur].querySelector('img');
      lbImg.src = fullSrc(visible[lbCur]); lbImg.alt = im.alt;
      lbI.textContent = lbCur + 1; lbN.textContent = visible.length;
      lbPrev.hidden = lbCur === 0; lbNext.hidden = lbCur >= visible.length - 1;
      [lbCur - 1, lbCur + 1].forEach(function (k) { if (visible[k]) { var p = new Image(); p.src = fullSrc(visible[k]); } });
    }
    function lbOpen(i) { lastFocus = document.activeElement; lbShow(i); lb.hidden = false; document.body.classList.add('pspdp-lb-open'); lbClose.focus(); }
    function lbHide() { lb.hidden = true; lb.classList.remove('zoomed'); document.body.classList.remove('pspdp-lb-open'); goTo(lbCur); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    function panTo(x, y) { stage.scrollLeft = x * (stage.scrollWidth - stage.clientWidth); stage.scrollTop = y * (stage.scrollHeight - stage.clientHeight); }
    function rel(e) { var r = stage.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; }
    track.addEventListener('click', function (e) { var li = e.target.closest('.pspdp-gitem'); if (li && visible.indexOf(li) > -1) lbOpen(visible.indexOf(li)); });
    var hint = root.querySelector('.pspdp-zoomhint'); if (hint) hint.addEventListener('click', function () { lbOpen(cur); });
    stage.addEventListener('click', function (e) {
      if (e.target !== lbImg) { lbHide(); return; }
      var p = rel(e); var on = lb.classList.toggle('zoomed'); if (on) panTo(p[0], p[1]);
    });
    if (window.matchMedia('(hover:hover)').matches) stage.addEventListener('mousemove', function (e) { if (lb.classList.contains('zoomed')) { var p = rel(e); panTo(p[0], p[1]); } });
    stage.addEventListener('touchstart', function (e) { touchX = lb.classList.contains('zoomed') ? null : e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (touchX === null) return; var dx = e.changedTouches[0].clientX - touchX; touchX = null; if (Math.abs(dx) > 50) lbShow(lbCur + (dx < 0 ? 1 : -1)); }, { passive: true });
    lbPrev.addEventListener('click', function () { lbShow(lbCur - 1); });
    lbNext.addEventListener('click', function () { lbShow(lbCur + 1); });
    lbClose.addEventListener('click', lbHide);
    document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') lbHide(); if (e.key === 'ArrowLeft') lbShow(lbCur - 1); if (e.key === 'ArrowRight') lbShow(lbCur + 1); });
  }

  /* ---------- multibuy offer: tiers, add-to-cart total, cart meter ---------- */
  var offer = cfg.offer || null, tiersEl = root.querySelector('.pspdp-tiers'), meter = document.getElementById('pspdp-meter');
  function qtyNow() { var qi = root.querySelector('.pspdp-qty input'); return Math.max(1, parseInt(qi && qi.value, 10) || 1); }
  function offerMath(qty, price) {
    if (!offer) return { free: 0, total: qty * price, save: 0, each: price };
    var bundle = offer.buy + offer.free, free = Math.floor(qty / bundle) * offer.free, pay = qty - free;
    return { free: free, total: pay * price, save: free * price, each: Math.round(pay * price / qty) };
  }
  /* ---------- pre-order: a size is a pre-order when it can be bought with no stock on hand ---------- */
  var pre = cfg.preorder || null;
  function isPre(v) {
    if (!pre || !v || !v.available) return false;
    if (pre.force) return true;
    return (pre.ids || []).indexOf(v.id) > -1; // decided in Liquid: the storefront variant JSON has no stock fields
  }
  function paintPre(v) {
    var on = isPre(v);
    root.classList.toggle('is-preorder', on);
    var strap = document.getElementById('pspdp-pre'); if (strap) strap.hidden = !on;
    var prop = document.getElementById('pspdp-pre-prop'); if (prop) prop.disabled = !on;
    var badge = root.querySelector('.pspdp-gbadge--pre'); if (badge) badge.hidden = !on;
    root.querySelectorAll('.pspdp-dispatch-live, .pspdp-trust-live').forEach(function (el) { el.hidden = on; });
    root.querySelectorAll('.pspdp-dispatch-pre, .pspdp-trust-pre').forEach(function (el) { el.hidden = !on; });
  }
  function atcLabel(v) {
    if (isPre(v)) return pre.label || 'Pre-order';
    if (!offer || !v) return 'Add to cart';
    var qty = qtyNow();
    return (qty > 1 ? 'Add ' + qty + ' to cart' : 'Add to cart') + ' \u00b7 ' + money(offerMath(qty, v.price).total);
  }
  function paintTiers(v) {
    if (!tiersEl || !v) return;
    var qty = qtyNow();
    Array.prototype.forEach.call(tiersEl.querySelectorAll('.pspdp-tier'), function (t) {
      var tq = +t.dataset.qty, m = offerMath(tq, v.price), on = tq === qty;
      t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on);
      t.querySelector('.pspdp-tier-total').textContent = money(m.total);
      t.querySelector('.pspdp-tier-sub').textContent = m.free ? money(m.each) + ' each \u00b7 save ' + money(m.save) : money(m.each) + ' each';
    });
  }
  function paintMeter(cart) {
    if (!meter || !offer) return;
    var n = 0; (cart.items || []).forEach(function (it) { if (offer.eligible.indexOf(it.product_id) > -1) n += it.quantity; });
    if (!n) { meter.hidden = true; return; }
    var bundle = offer.buy + offer.free, free = Math.floor(n / bundle) * offer.free, inCycle = n % bundle, more = bundle - inCycle;
    Array.prototype.forEach.call(meter.querySelectorAll('.pspdp-meter-cells i'), function (c, i) { c.classList.toggle('on', i < (inCycle === 0 ? bundle : inCycle)); });
    var unit = n === 1 ? meter.dataset.unit : meter.dataset.units;
    var txt = (free > 0 ? offer.meterDone : offer.meterText) || '';
    txt = txt.replace('[n]', n + ' ' + unit).replace('[more]', more).replace('[free]', free);
    meter.querySelector('.pspdp-meter-text').textContent = txt; meter.hidden = false;
  }
  function refreshMeter() {
    if (!meter || !offer) return;
    fetch(cfg.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(paintMeter).catch(function () {});
  }

  /* ---------- back in stock: a sold-out option swaps the buy row for an email alert form ----------
     The alert request and the marketing opt-in are sent separately: the alert always (they asked for it),
     marketing only when the unticked box is ticked. Klaviyo client API, public key only. data-send="0" = preview. */
  var nf = document.getElementById('pspdp-notify');
  var nfAsk = document.getElementById('pspdp-notify-ask'), nfDone = document.getElementById('pspdp-notify-done');
  var nfForm = document.getElementById('pspdp-notify-form'), nfEmail = document.getElementById('pspdp-notify-email');
  var nfMkt = document.getElementById('pspdp-notify-mkt'), nfBtn = document.getElementById('pspdp-notify-btn'), nfErr = document.getElementById('pspdp-notify-err');
  var nfWhat = document.getElementById('pspdp-notify-what'), nfDoneText = document.getElementById('pspdp-notify-done-text');
  var nfVariant = null;
  function optLabel(v) { return v && v.title && v.title !== 'Default Title' ? v.title : ''; }
  function nfReset() { if (!nf) return; nfAsk.hidden = false; nfDone.hidden = true; nfErr.hidden = true; nfBtn.disabled = false; nfBtn.textContent = nfBtn.dataset.label || nfBtn.textContent; }
  function paintNotify(v) {
    if (!nf) return;
    var out = !!v && !v.available;
    nf.hidden = !out; root.classList.toggle('is-soldout', out);
    var row = root.querySelector('.pspdp-qtyrow'); if (row) row.hidden = out;
    if (tiersEl) tiersEl.hidden = out;
    if (!out) return;
    if (!nfVariant || nfVariant.id !== v.id) nfReset();
    nfVariant = v;
    var lab = optLabel(v); nfWhat.textContent = lab ? 'Sold out in ' + lab + '.' : 'Sold out.';
  }
  if (nf) {
    nfBtn.dataset.label = nfBtn.textContent;
    var klaviyo = function (path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(nf.dataset.company), {
        method: 'POST', body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' }
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
    };
    nfForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = nfEmail.value.trim(), v = nfVariant, mkt = !!(nfMkt && nfMkt.checked);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { nfErr.textContent = 'Please enter a valid email address.'; nfErr.hidden = false; nfEmail.focus(); return; }
      if (!v) return;
      nfErr.hidden = true; nfBtn.disabled = true; nfBtn.textContent = 'Sending…';
      var live = nf.dataset.send === '1' && !!nf.dataset.company, jobs = [];
      if (live) {
        jobs.push(klaviyo('back-in-stock-subscriptions', { data: { type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } }));
        if (mkt && nf.dataset.list) jobs.push(klaviyo('subscriptions', { data: { type: 'subscription',
          attributes: { custom_source: 'Panastore back in stock form', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: nf.dataset.list } } } } }));
      }
      Promise.all(jobs).then(function () {
        var t = nf.dataset.title; // most titles are stored in capitals: soften them for a sentence
        if (t === t.toUpperCase()) t = t.toLowerCase().replace(/(^|[\s\/(-])([a-z])/g, function (m, a, c) { return a + c.toUpperCase(); });
        var lab = optLabel(v), what = 'the ' + t + (lab ? ' in ' + lab : '');
        nfDoneText.textContent = 'We’ll email ' + email + ' when ' + what + ' is back.' + (mkt ? ' To get Panastore news and offers too, click the link in the confirmation email we’ve just sent.' : '') + (live ? '' : ' (Preview: nothing was sent.)');
        nfAsk.hidden = true; nfDone.hidden = false;
      }).catch(function () {
        nfBtn.disabled = false; nfBtn.textContent = nfBtn.dataset.label;
        nfErr.textContent = 'That didn’t go through. Please try again, or email info@panastoreonline.co.uk.'; nfErr.hidden = false;
      });
    });
    document.getElementById('pspdp-notify-again').addEventListener('click', function () { nfReset(); nfEmail.value = ''; if (nfMkt) nfMkt.checked = false; nfEmail.focus(); });
  }

  /* ---------- variants ---------- */
  var idInput = document.getElementById('pspdp-variant-id'), priceEl = document.getElementById('pspdp-price'), skuEl = document.getElementById('pspdp-sku');
  var atc = document.getElementById('pspdp-atc');
  var groups = Array.prototype.slice.call(root.querySelectorAll('.pspdp-swatches'));
  function selected() { return groups.map(function (g) { var on = g.querySelector('.pspdp-sw.is-on'); return on ? on.dataset.value : null; }); }
  function findVariant(opts) { return variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); })[0]; }
  function paintStock() {
    var sel = selected();
    groups.forEach(function (g, gi) {
      Array.prototype.forEach.call(g.querySelectorAll('.pspdp-sw'), function (b) {
        var probe = sel.slice(); probe[gi] = b.dataset.value;
        var v = findVariant(probe); var oos = !v || !v.available;
        b.classList.toggle('is-oos', oos); b.setAttribute('aria-disabled', oos);
      });
    });
  }
  /* ---------- optional add-on: a second product bought with this one at its own price, one per unit ----------
     A pair of radio options above Add to cart; prices follow the selected variant. Chosen = two lines in one add. */
  var addonEl = document.getElementById('pspdp-addon');
  function addonOn() { var r = addonEl && addonEl.querySelector('input[value="1"]'); return !!(cfg.addon && r && r.checked); }
  function paintAddon(v) {
    if (!addonEl || !cfg.addon || !v) return;
    var a = document.getElementById('pspdp-aopt-a'), b = document.getElementById('pspdp-aopt-b');
    if (a) a.textContent = money(v.price); if (b) b.textContent = money(v.price + cfg.addon.price);
    priceEl.textContent = money(v.price + (addonOn() ? cfg.addon.price : 0)); // the big price is what Add to cart will charge
  }
  if (addonEl) addonEl.addEventListener('change', function () {
    Array.prototype.forEach.call(addonEl.querySelectorAll('.pspdp-aopt'), function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
    paintAddon(currentVariant());
  });

  function apply(v) {
    if (!v) return;
    idInput.value = v.id; priceEl.textContent = money(v.price); skuEl.textContent = v.sku || ''; paintAddon(v);
    atc.disabled = !v.available; atc.textContent = v.available ? atcLabel(v) : 'Sold out';
    var skuRow = skuEl.parentNode; if (skuRow) skuRow.hidden = !v.sku;
    paintTiers(v); paintPre(v); paintNotify(v);
    root.querySelectorAll('.pspdp-optcur').forEach(function (s) { s.textContent = v.options[+s.dataset.option]; });
    paintStock(); arrange(v);
    if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
  }
  groups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.pspdp-sw'); if (!b) return;
      if (b.classList.contains('is-oos')) { // sold out: selectable only for the back in stock form, and only if that option exists
        if (!nf) return;
        var probe = selected(); probe[+b.dataset.optionIndex] = b.dataset.value; if (!findVariant(probe)) return;
      }
      Array.prototype.forEach.call(g.querySelectorAll('.pspdp-sw'), function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
      apply(findVariant(selected()));
    });
  });
  apply(variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0]);

  /* ---------- quantity ---------- */
  var q = root.querySelector('.pspdp-qty input');
  function currentVariant() { return variants.filter(function (v) { return String(v.id) === idInput.value; })[0]; }
  function qtyChanged() { var v = currentVariant(); paintTiers(v); if (v && v.available) atc.textContent = atcLabel(v); }
  root.querySelectorAll('.pspdp-qty button').forEach(function (b, i) { b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (i ? 1 : -1)); qtyChanged(); }); });
  q.addEventListener('input', qtyChanged); q.addEventListener('change', function () { q.value = qtyNow(); qtyChanged(); });
  if (tiersEl) tiersEl.addEventListener('click', function (e) { var t = e.target.closest('.pspdp-tier'); if (!t) return; q.value = t.dataset.qty; qtyChanged(); });
  refreshMeter();

  /* ---------- add to cart: Dawn cart drawer if present, otherwise the cart page ---------- */
  // Dawn's cart UI: <cart-notification> (theme setting "notification", what the live site uses) or <cart-drawer>.
  // Both expose getSectionsToRender() + renderContents(); we ask for exactly the sections they need.
  function cartUI() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
  function cartSections(ui) {
    if (ui && typeof ui.getSectionsToRender === 'function') return ui.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    return ui ? (ui.tagName.toLowerCase() + ',cart-icon-bubble') : 'cart-icon-bubble';
  }
  var form = document.getElementById('pspdp-form');
  form.addEventListener('submit', function (e) {
    e.preventDefault(); if (atc.disabled) return;
    var drawer = cartUI(), fd = new FormData(form);
    atc.textContent = 'Adding\u2026';
    var req, extra = cfg.gift ? cfg.gift.variant : (addonOn() ? cfg.addon.variant : null);
    fd.delete('pspdp_addon');
    if (extra) {
      // product + a second line (its free gift, or the add-on the customer chose) in ONE add, one per unit;
      // a gift is zeroed in the cart by Shopify's automatic discount, an add-on is simply bought at its price
      var qty = qtyNow(), props = {};
      fd.forEach(function (val, key) { var m = /^properties\[(.+)\]$/.exec(key); if (m) props[m[1]] = val; });
      var item = { id: +idInput.value, quantity: qty }; if (Object.keys(props).length) item.properties = props;
      req = fetch(cfg.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: extra, quantity: qty }, item], sections: cartSections(drawer), sections_url: location.pathname }) });
    } else {
      fd.append('sections', cartSections(drawer)); fd.append('sections_url', location.pathname);
      req = fetch(cfg.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } });
    }
    req.then(function (r) { return r.json(); })
      .then(function (res) {
        atc.textContent = atcLabel(currentVariant());
        if (res.status) { alert(res.description || 'Could not add to cart'); return; }
        if (res.items && !res.key) { // multi-item response: the notification shows the product, not the gift or add-on
          var main = res.items.filter(function (it) { return String(it.variant_id) === idInput.value; })[0] || res.items[res.items.length - 1];
          res.key = main.key;
        }
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); refreshMeter(); }
        else { location.href = cfg.cartUrl; }
      }).catch(function () { atc.textContent = atcLabel(currentVariant()); location.href = cfg.cartUrl; });
  });

  /* ---------- cross-sell cards: same drawer add; size select updates the card price ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.pspdp-xsel'); if (!sel) return;
    var price = sel.closest('.pspdp-row').querySelector('.pspdp-xprice'), opt = sel.options[sel.selectedIndex];
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
    var btn = sel.closest('.pspdp-xform') && sel.closest('.pspdp-xform').querySelector('button[type=submit]');
    if (btn && opt) { btn.disabled = !!opt.disabled; btn.textContent = opt.disabled ? 'Sold out' : 'Add'; }
    var tile = sel.closest('li') && sel.closest('li').querySelector('.pspdp-xmedia'), img = tile && tile.querySelector('img');
    if (img && opt && opt.dataset.img) { img.src = opt.dataset.img; img.removeAttribute('srcset'); tile.classList.remove('has-alt'); }
  });
  document.addEventListener('submit', function (e) {
    var xf = e.target.closest('.pspdp-xform'); if (!xf) return;
    e.preventDefault();
    var btn = xf.querySelector('button'), drawer = cartUI(), fd = new FormData(xf);
    if (!btn || btn.disabled) return;
    fd.append('sections', cartSections(drawer)); fd.append('sections_url', location.pathname);
    var label = btn.textContent; btn.textContent = '…'; btn.disabled = true;
    fetch(cfg.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.textContent = label; btn.disabled = false;
        if (res.status) { alert(res.description || 'Could not add to cart'); return; }
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); refreshMeter(); } else { location.href = cfg.cartUrl; }
      }).catch(function () { btn.textContent = label; btn.disabled = false; location.href = cfg.cartUrl; });
  });

  /* ---------- dispatch line ----------
     Rule (shipping policy): orders before the cutoff on a working day are dispatched that day;
     otherwise on the next working day. Working day = Mon-Fri and not a bank holiday / closure.
     London time is read as PARTS via Intl — never by parsing a locale string, which JavaScript
     reads as month/day and once turned 3 September into 9 March. */
  function pspdpDispatch(nowMs, holidays, cutoffH, cutoffM) {
    var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    var p = {}; fmt.formatToParts(new Date(nowMs)).forEach(function (x) { p[x.type] = x.value; });
    var y = +p.year, mo = +p.month, d = +p.day, h = +p.hour % 24, mi = +p.minute;
    var iso = function (dt) { return dt.getUTCFullYear() + '-' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0'); };
    var today = new Date(Date.UTC(y, mo - 1, d));
    var working = function (dt) { var wd = dt.getUTCDay(); return wd !== 0 && wd !== 6 && holidays.indexOf(iso(dt)) < 0; };
    if (working(today) && (h * 60 + mi) < (cutoffH * 60 + cutoffM)) {
      var mins = cutoffH * 60 + cutoffM - (h * 60 + mi);
      return { lead: 'Order in the next ' + Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm', tail: 'for dispatch today' };
    }
    var nxt = new Date(today), steps = 0;
    do { nxt.setUTCDate(nxt.getUTCDate() + 1); steps++; } while (!working(nxt) && steps < 30);
    var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var when = names[nxt.getUTCDay()] + (steps === 1 ? ' (tomorrow)' : steps > 2 ? ' ' + nxt.getUTCDate() + ' ' + months[nxt.getUTCMonth()] : '');
    return { lead: 'Order now', tail: 'for dispatch on ' + when };
  }
  window.pspdpDispatch = pspdpDispatch;
  function dispatch() {
    var box = document.querySelector('.pspdp-dispatch'), l1 = document.getElementById('pspdp-dl1'), l2 = document.getElementById('pspdp-dl2'); if (!box || !l1) return;
    var hol = (box.dataset.holidays || '').split(/[,\s]+/).filter(Boolean);
    var cut = (box.dataset.cutoff || '13:00').split(':');
    var r = pspdpDispatch(Date.now(), hol, +cut[0], +cut[1] || 0);
    l1.textContent = r.lead; l2.textContent = r.tail;
  }
  dispatch(); setInterval(dispatch, 30000);

  /* ---------- description clamp ---------- */
  var box = root.querySelector('.pspdp-desc');
  if (box) {
    var t = box.querySelector('.pspdp-desc-text'), b = box.querySelector('.pspdp-more');
    function chk() { if (box.classList.contains('open')) return; b.hidden = !(t.scrollHeight > t.clientHeight + 1); }
    b.addEventListener('click', function () { var o = box.classList.toggle('open'); b.textContent = o ? 'Read less' : 'Read more'; b.setAttribute('aria-expanded', o); });
    chk(); window.addEventListener('resize', chk);
  }

})();
